// Angular Imports
import { Component, Input, booleanAttribute, input } from '@angular/core'
// Shared Imports
import { TitleCaseNumberPipe } from '@shared/pipes'

@Component({
	selector: 'app-pill',
	standalone: true,
	imports: [TitleCaseNumberPipe],
	templateUrl: './pill.component.html',
	styleUrls: ['./pill.component.scss'],
})
export class PillComponent {
	value = input.required<string | undefined>()
	full = input(false, { transform: booleanAttribute })
	text = input<string>()
}
